import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/font/google/target.css?{\"path\":\"src/lib/dm-sans-font.ts\",\"import\":\"DM_Sans\",\"arguments\":[{\"weight\":\"variable\",\"axes\":[\"opsz\"],\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-dm-sans\"}],\"variableName\":\"dmSans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/opt/build/repo/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/opt/build/repo/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/opt/build/repo/src/contexts/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/styles/index.css");
